import { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import hotelImg from "../assests/images/hotel-bg.jpg";
import Hero from "../components/Hero";
import { useLocation } from "react-router-dom";

import {
    FaHeart,
    FaRegHeart,
    FaMapMarkerAlt,
    FaStar,
    FaStarHalfAlt,
    FaRegStar,
    FaSearch,
    FaMoneyBillWave,
    FaMapMarkedAlt,
    FaUndo
} from "react-icons/fa";



export default function HotelList({
    limit,
    showViewAllButton = false,
    showSidebar = true,
    showBanner = false,
    showHeading = false   // ✅ ADD THIS
}) {

    const [hotels, setHotels] = useState([]);
    const [loading, setLoading] = useState(true);

    const location = useLocation();

    // Wishlist
    const [wishlist, setWishlist] = useState([]);

    // Filters
    const [search, setSearch] = useState("");
    const [minPrice, setMinPrice] = useState(0);
    const [maxPrice, setMaxPrice] = useState(5000);
    const [rating, setRating] = useState(0);

    const [destinations, setDestinations] = useState([]);
    const [selectedDestinations, setSelectedDestinations] = useState([]);

    const navigate = useNavigate();

    // ✅ LOAD WISHLIST FROM LOCALSTORAGE
    useEffect(() => {
        const storedWishlist = JSON.parse(localStorage.getItem("wishlist")) || [];
        setWishlist(storedWishlist);
    }, []);

    // ✅ UPDATE WISHLIST
    const updateWishlist = (updated) => {
        setWishlist(updated);
        localStorage.setItem("wishlist", JSON.stringify(updated));
    };

    // ✅ TOGGLE WISHLIST
    const toggleWishlist = (hotel) => {
        const exists = wishlist.find(item => item.id === hotel.id);

        let updated;
        if (exists) {
            updated = wishlist.filter(item => item.id !== hotel.id);
        } else {
            updated = [...wishlist, hotel];
        }

        updateWishlist(updated);
    };

    // ✅ CHECK IF IN WISHLIST
    const isWishlisted = (id) => {
        return wishlist.some(item => item.id === id);
    };

    // Fetch Destinations
    const fetchDestinations = async () => {
        try {
            const res = await axios.get("https://beachhotelsdubai.com/api/destinations");
            setDestinations(res.data);
        } catch (err) {
            console.error(err);
        }
    };

    useEffect(() => {
        fetchDestinations();
    }, []);

    const handleDestinationChange = (dest) => {
        setSelectedDestinations((prev) =>
            prev.some(d => d.id === dest.id)
                ? prev.filter((d) => d.id !== dest.id)
                : [...prev, dest]
        );
    };

    // Debounce search
    const [debouncedSearch, setDebouncedSearch] = useState(search);

    useEffect(() => {
        const handler = setTimeout(() => {
            setDebouncedSearch(search);
        }, 500);

        return () => clearTimeout(handler);
    }, [search]);

    // Fetch Hotels
    const fetchHotels = async () => {
        setLoading(true);
        try {
            const res = await axios.get("https://beachhotelsdubai.com/api/hotels", {
                params: {
                    search: debouncedSearch,
                    destinations: selectedDestinations.map(d => d.id),
                    minPrice,
                    maxPrice,
                    rating,
                },
            });

            setHotels(res.data);
        } catch (err) {
            console.error(err);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchHotels();
    }, [debouncedSearch, minPrice, maxPrice, rating, selectedDestinations]);

    // Stars
    const renderStars = (ratingValue) => {
        return Array.from({ length: 5 }, (_, i) => {
            if (i < Math.floor(ratingValue)) return <FaStar key={i} />;
            if (i === Math.floor(ratingValue) && ratingValue % 1 >= 0.5)
                return <FaStarHalfAlt key={i} />;
            return <FaRegStar key={i} />;
        });
    };

    // Reset Filters
    const isFilterChanged =
        search !== "" ||
        minPrice !== 0 ||
        maxPrice !== 5000 ||
        rating !== 0 ||
        selectedDestinations.length > 0;

    const resetFilters = () => {
        setSearch("");
        setMinPrice(0);
        setMaxPrice(5000);
        setRating(0);
        setSelectedDestinations([]);
    };



    return (





        <div className="w-full">
            {showBanner && (
                <Hero
                    variant="inner"
                    title="All Hotels"
                    subtitle="Explore the best stays and experiences"
                    backgroundImage={hotelImg}
                />
            )}
            <div
                className={`mx-auto ${showBanner ? "max-w-screen-2xl" : "max-w-7xl"
                    } px-4 lg:px-8 py-10 sm:py-12 md:py-16 lg:py-20`}
            >
                {/* Heading */}

                {showHeading && (
                    <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-6 mb-12">

                        <div>
                            <span className="inline-flex items-center px-4 py-2 rounded-full bg-orange-100 text-[#0F172A] text-sm font-semibold mb-4">
                                Hotel Collection
                            </span>

                            <h2 className="text-3xl md:text-4xl font-bold text-slate-900">
                                Find Your Perfect Stay
                            </h2>

                            <p className="text-slate-500 mt-3 max-w-2xl">
                                Browse luxury hotels, resorts and budget-friendly stays
                                across Dubai's most popular destinations.
                            </p>
                        </div>

                        <button
                            onClick={() => navigate("/hotels")}
                            className="hidden sm:flex items-center gap-2 px-6 py-3 bg-[#0F172A] text-white rounded-xl hover:bg-orange-600 transition"
                        >
                            View All Hotels →
                        </button>

                    </div>
                )}

                {/* Layout */}
                <div className="flex flex-col lg:flex-row gap-6 lg:gap-8">
                    {/* Sidebar */}
                    {showSidebar && (
                        <div className="w-full lg:w-1/4">
                            <div className="lg:sticky lg:top-28">
                                <div className="bg-white rounded-[28px] border border-orange-100 shadow-[0_15px_40px_rgba(15,23,42,0.08)] rounded-[32px] p-4 sm:p-5 lg:p-6 space-y-6 sm:space-y-8">
                                    {/* Header */}
                                    <div className="flex justify-between items-center gap-3">
                                        <h3 className="text-xl font-bold text-slate-900">
                                            Filter Hotels
                                        </h3>

                                        {isFilterChanged && (
                                            <button
                                                onClick={resetFilters}
                                                className="flex items-center gap-1 text-xs bg-orange-100 text-[#0F172A] px-3 py-1.5 rounded-full hover:bg-red-100 transition"
                                            >
                                                <FaUndo />
                                                Reset
                                            </button>
                                        )}
                                    </div>

                                    {/* Search */}
                                    <div>
                                        <label className="text-sm font-semibold text-gray-600 flex items-center gap-2">
                                            <FaSearch className="text-[#0F172A]" />
                                            Search
                                        </label>

                                        <input
                                            type="text"
                                            value={search}
                                            onChange={(e) => setSearch(e.target.value)}
                                            placeholder="Hotel or destination..."
                                            className="w-full mt-3 px-4 py-3 rounded-xl border border-gray-200 focus:ring-2 focus:ring-[#0F172A] focus:border-[#0F172A] transition shadow-sm text-sm sm:text-base"
                                        />
                                    </div>

                                    {/* Price */}
                                    <div>
                                        <label className="text-sm font-semibold text-gray-600 flex items-center gap-2">
                                            <FaMoneyBillWave className="text-green-500" />
                                            Price Range
                                        </label>

                                        <div className="flex flex-col sm:flex-row gap-3 mt-3">
                                            <input
                                                type="number"
                                                value={minPrice}
                                                onChange={(e) => setMinPrice(e.target.value)}
                                                placeholder="Min"
                                                className="w-full sm:w-1/2 px-3 py-3 rounded-xl border border-gray-200 focus:ring-2 focus:ring-[#0F172A] shadow-sm text-sm sm:text-base"
                                            />

                                            <input
                                                type="number"
                                                value={maxPrice}
                                                onChange={(e) => setMaxPrice(e.target.value)}
                                                placeholder="Max"
                                                className="w-full sm:w-1/2 px-3 py-3 rounded-xl border border-gray-200 focus:ring-2 focus:ring-[#0F172A] shadow-sm text-sm sm:text-base"
                                            />
                                        </div>
                                    </div>

                                    {/* Rating */}
                                    <div>
                                        <label className="text-sm font-semibold text-gray-600 flex items-center gap-2">
                                            <FaStar className="text-yellow-500" />
                                            Rating
                                        </label>

                                        <select
                                            value={rating}
                                            onChange={(e) => setRating(e.target.value)}
                                            className="w-full mt-3 px-4 py-3 rounded-xl border border-gray-200 bg-white focus:ring-2 focus:ring-[#0F172A] shadow-sm text-sm sm:text-base"
                                        >
                                            <option value="0">All Ratings</option>
                                            <option value="3">3★ & above</option>
                                            <option value="4">4★ & above</option>
                                            <option value="4.5">4.5★ & above</option>
                                        </select>
                                    </div>

                                    {/* Destinations */}
                                    <div>
                                        <label className="text-sm font-semibold text-gray-600 flex items-center gap-2">
                                            <FaMapMarkedAlt className="text-blue-500" />
                                            Destinations
                                        </label>

                                        <div className="mt-3 max-h-52 overflow-y-auto space-y-2 pr-1">
                                            {destinations.map((dest) => {
                                                const isChecked = selectedDestinations.some(
                                                    (d) => d.id === dest.id
                                                );

                                                return (
                                                    <label
                                                        key={dest.id}
                                                        className={`flex items-center justify-between px-3 py-2 rounded-xl cursor-pointer transition border ${isChecked
                                                            ? "bg-orange-100 border-[#0F172A] shadow-sm"
                                                            : "border-transparent hover:bg-gray-100"
                                                            }`}
                                                    >
                                                        <span className="text-sm text-gray-700">
                                                            {dest.name}
                                                        </span>

                                                        <input
                                                            type="checkbox"
                                                            checked={isChecked}
                                                            onChange={() => handleDestinationChange(dest)}
                                                            className="accent-[#0F172A]"
                                                        />
                                                    </label>
                                                );
                                            })}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}

                    {/* Hotels */}
                    <div className={showSidebar ? "w-full lg:w-3/4" : "w-full"}>

                        {/* Top Bar */}
                        {location.pathname === "/hotels" && (
                            <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4 mb-8">
                                <div>
                                    <h2 className="text-3xl font-bold text-slate-900">
                                        Showing
                                        <span className="text-[#0F172A]"> {hotels.length} </span>
                                        Hotels
                                    </h2>

                                    <p className="text-slate-500 mt-1">
                                        Discover luxury stays across Dubai
                                    </p>
                                </div>
                            </div>
                        )}

                        {loading ? (
                            <div className="flex justify-center py-20">
                                <div className="animate-spin h-12 w-12 border-4 border-[#0F172A] border-t-transparent rounded-full"></div>
                            </div>
                        ) : (
                            <>
                                <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-5 sm:gap-6">
                                    {(limit ? hotels.slice(0, limit) : hotels).map((hotel) => (
                                        <div
                                            key={hotel.id}
                                            className="
    group
    bg-white
    rounded-[28px]
    border border-slate-100
    shadow-lg
    hover:shadow-2xl
    overflow-hidden
    transition-all
    duration-500
    ">
                                            {/* Image */}
                                            <div
                                                className="relative h-[240px] overflow-hidden cursor-pointer"
                                                onClick={() => navigate(`/hotels/${hotel.slug}`)}
                                            >
                                                <img
                                                    src={`https://uaediscountedhotels.com/uploads/hotels/${hotel.image}`}
                                                    alt={hotel.name}
                                                    className="w-full h-full object-cover group-hover:scale-110 transition duration-700"
                                                />

                                                <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent"></div>

                                                {/* Destination Badge */}
                                                <div className="absolute top-4 left-4 z-20">
                                                    <span className="bg-white/95 backdrop-blur px-3 py-1 rounded-full text-xs font-medium text-slate-700">
                                                        {hotel.location || "Dubai"}
                                                    </span>
                                                </div>

                                                {/* Wishlist */}
                                                <button
                                                    onClick={(e) => {
                                                        e.stopPropagation();
                                                        toggleWishlist(hotel);
                                                    }}
                                                    className="absolute top-4 right-4 z-20 w-10 h-10 rounded-full bg-white shadow-lg flex items-center justify-center"
                                                >
                                                    {isWishlisted(hotel.id)
                                                        ? <FaHeart className="text-red-500" />
                                                        : <FaRegHeart className="text-gray-500" />}
                                                </button>

                                                {/* Price */}
                                                <div className="absolute bottom-4 right-4 z-20 bg-[#0F172A] text-white rounded-2xl px-4 py-2 shadow-xl">
                                                    <p className="text-[10px] uppercase opacity-90">
                                                        From
                                                    </p>

                                                    <p className="font-bold text-sm">
                                                        AED {Math.round(hotel.price_per_night)}
                                                    </p>
                                                </div>
                                            </div>

                                            {/* Content */}
                                            <div className="p-6">

                                                <h3 className="font-bold text-xl text-slate-900 line-clamp-1">
                                                    {hotel.name}
                                                </h3>

                                                <div className="flex items-center gap-2 mt-2 text-slate-500">
                                                    <FaMapMarkerAlt className="text-[#0F172A]" />

                                                    <span className="text-sm">
                                                        {hotel.location}
                                                    </span>
                                                </div>

                                                {/* Rating */}
                                                <div className="flex items-center gap-1 text-yellow-500 mt-3">
                                                    {renderStars(hotel.rating)}
                                                </div>

                                                {/* Description */}
                                                <p className="text-slate-600 text-sm mt-4 leading-6 line-clamp-2 min-h-[48px]">
                                                    {hotel.short_description?.replace(/<[^>]*>/g, "")}
                                                </p>

                                                {/* Amenities */}
                                                <div className="flex flex-wrap gap-3 text-xs text-slate-500 mt-4 border-t border-slate-100 pt-4">

                                                    <span>🏊 Pool</span>

                                                    <span>📶 WiFi</span>

                                                    <span>🍽 Restaurant</span>
                                                </div>

                                                {/* Footer */}
                                                <div className="flex justify-between items-center mt-5">

                                                    <button
                                                        onClick={() => navigate(`/hotels/${hotel.slug}`)}
                                                        className="font-semibold text-[#0F172A] hover:translate-x-1 transition"
                                                    >
                                                        View Details →
                                                    </button>

                                                    <div className="bg-orange-100 px-3 py-1 rounded-full text-sm font-semibold text-[#0F172A]">
                                                        ★ {hotel.rating || "4.5"}
                                                    </div>

                                                </div>

                                            </div>
                                        </div>
                                    ))}
                                </div>

                                {/* Mobile View All Button */}
                                {showHeading && (
                                    <div className="mt-8 sm:hidden">
                                        <button
                                            onClick={() => navigate("/hotels")}
                                            className="w-full bg-[#0F172A] text-white px-5 py-3 rounded-xl hover:bg-orange-600 transition text-sm font-medium"
                                        >
                                            View All
                                        </button>
                                    </div>
                                )}
                            </>
                        )}
                    </div>
                </div>
            </div>
        </div>

    );
}